import { useMemo } from "react";
import { AppDialog } from "../../../common/components/AppDialog/AppDialog";
import { faqItems, NOTIFICATIONS_FAQ_ID } from "./faqItems";
import { FaqAccordion } from "./FaqAccordion";
import { useAppContext } from "../../../AppContext";
import { FeatureFlagKey } from "../../../common/enums";
import { useFeatureFlag } from "../../../common/infrastructure/hooks/useFeatureFlag";

interface IFaqDialogProps {
  visible: boolean;
  onHide: () => void;
}

export const FaqDialog = ({ visible, onHide }: IFaqDialogProps) => {
  const { isDesktopOrTablet } = useAppContext();
  const notificationsEnabled = useFeatureFlag(FeatureFlagKey.EnableAppNotifications, false);
  // The notifications entry explains a feature the studio may not have turned on.
  const items = useMemo(
    () =>
      notificationsEnabled
        ? faqItems
        : faqItems.filter((item) => item.id !== NOTIFICATIONS_FAQ_ID),
    [notificationsEnabled],
  );

  return (
    <AppDialog
      header="Често задавани въпроси"
      visible={visible}
      style={{ width: isDesktopOrTablet ? "640px" : "94vw" }}
      onHide={onHide}
    >
      <FaqAccordion items={items} />
    </AppDialog>
  );
};
